<script setup lang="ts">
import { NCard, NTag, NGrid, NGi } from 'naive-ui'
import {submitRequirementsIcon, reviewCandidatesIcon, bookMeetingIcon, getAugmentedIcon } from '@/assets/utils/icons'

const steps = [
  {
    icon: submitRequirementsIcon,
    text: "1. Submit your requirements",
    tag: null
  },
  {
    icon: reviewCandidatesIcon,
    text: "2. Review candidates",
    tag: null
  },
  {
    icon: bookMeetingIcon,
    text: "3. Book a meeting",
    tag: null
  },
  {
    icon: getAugmentedIcon,
    text: "Get started",
    tag: "AUGMENT",
    light: true,
    button: {
      routeName: 'client-project-create'
    }
  },

]
</script>

<template>
  <section class="start-guide">
    <p class="kicker">
      Welcome to Augmentify
    </p>

    <h1 class="heading h1 title">
      Let’s get started! Submit your project and Augment your team {{ api }}
    </h1>

    <p class="body-text body">
      It’s very easy, just follow these three steps
    </p>

    <n-card content-class="flex-container get-started-steps" size="medium" :bordered="false">
      <n-grid :x-gap="24" :cols="steps.length">
        <n-gi class="step-card" v-for="(step, key) in steps" :key="key">
          <router-link class="ripple-button" v-if="step.button" :to="{ name: step.button.routeName }">
            <n-card size="small" :bordered="false">
              <div class="grid-x flex-xy-center">
                <div class="cell small-4 medium-4 xxlarge-3">
                  <div class="step-icon" v-html="step.icon"></div>
                </div>
                <div class="cell small-8 medium-12 xxlarge-8 xxlarge-offset-1">
                  <span class="body-text-md step-card-text" :class="{ 'text-white': step.light }">{{ step.text }}</span>
                  <template v-if="step.tag">
                    <br>
                    <n-tag class="augment-tag" :bordered="false" type="success" size="small">{{ step.tag }}</n-tag>
                  </template>
                </div>
              </div>
            </n-card>
          </router-link>
          <n-card v-else content-class="step-card" size="small" :bordered="false">
            <div class="grid-x flex-xy-center">
              <div class="cell small-4 medium-4 xxlarge-3">
                <div class="step-icon" v-html="step.icon"></div>
              </div>
              <div class="cell small-8 medium-12 xxlarge-8 xxlarge-offset-1">
                <span class="body-text-md step-card-text" :class="{ 'text-white': step.light }">{{ step.text }}</span>
                <template v-if="step.tag">
                  <br>
                  <n-tag class="augment-tag" :bordered="false" type="success" size="small">{{ step.tag }}</n-tag>
                </template>
              </div>
            </div>
          </n-card>
        </n-gi>
      </n-grid>
    </n-card>
  </section>

</template>

<style lang="scss">
.start-guide{
  .title {
    margin: 24px 0;
  }

  .body {
    margin-bottom: 24px;
  }

  .get-started-steps {
    gap: 24px;

    .n-grid .step-card {
      &:first-child  .n-card {
        background-color: $purple-light-1;
      }

      &:nth-child(2) .n-card {
        background-color: $purple-light-2;
      }

      &:nth-child(3) .n-card {
        background-color: $purple-light-3;
      }

      &:nth-child(4) .n-card {
        background-color: $purple-medium;
      }

      .ripple-button {
        display: flex;
        position: relative;
        height: 100%;

        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: $purple-light-3;
          border-radius: 10px;
          z-index: 0;
          animation: ripple 1.5s ease-out infinite;
        }
      }

      .augment-tag {
        padding: 0 10px;
        cursor: pointer;
      }
    }

    .n-card {
      .step-card {
        display: grid;
        border-radius: 10px;


      }

      .step-icon {
        border-radius: 10px;
        background-color: #FFFFFF;
        padding: 5px 2px;
        display: grid;
        justify-content: center;
        align-items: center;
        min-height: 45px;
        min-width: 40px;
      }
    }
  }
}

</style>